<template>
  <div class="pager">
    <SearchPaginationSlidingPagination
      :current="page + 1"
      :total="totalPages"
      :class-map="classMap"
      class="pagination"
      page-component="PagerPage"
      @page-change="emit('page', $event)"
    />
  </div>
</template>

<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    page?: number
    total?: number
    perPage?: number
  }>(),
  {
    page: 0,
    total: 0,
    perPage: 24,
  },
)

const emit = defineEmits<{
  page: [number]
}>()

const classMap = {
  componentClass: 'pagination',
  list: 'pagination-list',
  element: 'is-text',
  elementDisabled: 'is-disabled',
  elementActive: 'is-primary',
  page: 'button',
}

const totalPages = computed(() => Math.ceil(props.total / props.perPage))
</script>

<style lang="postcss">
.pager {
  @apply mt-size-5 border-t border-solid border-grey px-0 py-size-5;
  @apply tablet:sticky tablet:bottom-0 tablet:z-100 tablet:bg-background;
}
</style>
